import axios from 'axios';
import {LOAD_THEMES, SELECT_THEME} from '../AppTemplateActions';

export const getAvailableThemes = () => async (dispatch) => {
    const config = {
        url: 'https://bootswatch.com/api/4.json',
        errorMessage: 'Something went wrong while loading available Themes',
        anonymous: true,
    };
    const result = await axios.request(config);
    dispatch({
        type: LOAD_THEMES,
        themes: result.data.themes.map(t => ({name: t.name, css: t.cssMin})),
    });
};

export const selectTheme = (theme) => {
    return {type: SELECT_THEME, theme};
};

export const getClientTheme = (publicUrl, callback) => async () => {
    const config = {
        url: '/profile',
        params: {public_url: publicUrl},
        errorMessage: 'Something went wrong while loading Client Theme',
    };
    const result = await axios.request(config);
    callback(result.data);
};


// WEBPACK FOOTER //
// ./src/containers/template/theme/ThemeApi.js